import { Journey } from '../../lib/types/models/product/journey'
import {
  JourneyRequest,
  JourneyTripOptionGroupInput
} from '../../lib/types/models/product/journey-input'
import { JourneyBasePriceInput } from '../../lib/types/models/product/product-input'
import { IdInput, IdsInput } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateJourney(data: IdInput<JourneyRequest>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.products.updateJourney.url, { id }))
    .patch<Journey, Partial<JourneyRequest>>(rest)
}

export const publishJourneys = (ids: number[]) => {
  return restApiClient
    .url(constructApiUrl(API.products.publishJourney.url, null))
    .post<Journey, IdsInput>({ ids })
}

export const unpublishJourneys = (ids: number[]) => {
  return restApiClient
    .url(constructApiUrl(API.products.unpublishJourney.url, null))
    .post<Journey, IdsInput>({ ids })
}

export const updateJourneyBasePrice = (data: IdsInput<JourneyBasePriceInput>) => {
  return restApiClient
    .url(constructApiUrl(API.products.updateProductDatesBasePrice.url, null))
    .patch<Journey>(data)
}

export const publishTripOptionGroup = (
  input: JourneyTripOptionGroupInput & { journeyId: number }
) => {
  const { journeyId, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.products.publishTripOptionGroup.url, { id: journeyId }))
    .post<JourneyTripOptionGroupInput>(rest)
}
export const unpublishTripOptionGroup = (
  input: JourneyTripOptionGroupInput & { journeyId: number }
) => {
  const { journeyId, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.products.unpublishTripOptionGroup.url, { id: journeyId }))
    .post<JourneyTripOptionGroupInput>(rest)
}
export const publishTripOption = (input: { journeyId: number; tripOptionId: number }) => {
  return restApiClient
    .url(
      constructApiUrl(API.products.publishTripOption.url, {
        id: input.journeyId,
        tripId: input.tripOptionId
      })
    )
    .post<unknown>()
}

export const unpublishTripOption = (input: { journeyId: number; tripOptionId: number }) => {
  return restApiClient
    .url(
      constructApiUrl(API.products.unpublishTripOption.url, {
        id: input.journeyId,
        tripId: input.tripOptionId
      })
    )
    .post<unknown>()
}

export const deleteTripOptionsGroup = (input: IdInput<JourneyTripOptionGroupInput>) => {
  const { id, ...rest } = input
  return restApiClient
    .url(
      encodeNestedObject<JourneyTripOptionGroupInput>(
        constructApiUrl(API.products.deleteTripOptionsGroup.url, { id }),
        rest
      )
    )
    .delete<unknown>()
}
